module.exports = __webpack_public_path__ + "static/img/8.00fceec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/8.png
// module id = NtaP
// module chunks = 0